<script>
    import SiteHeader from '../SiteHeader'

    export default {
        name: 'Index',
        components: {
            SiteHeader
        },
        created: () => {

        },
        mounted () {
        },
        data() {
            return {
                mykey: 'bar',

            }
        },
        methods: {

        }
        
    }
</script>

<template lang="pug">
.foo
    .row
      #left-col.col.s11.offset-s1.m11.offset-m1.l5.offset-l1
        img.img_educ(src='@/assets/svg/Asset4.svg')
        h5 BROWSE INDUSTRIES
        p.portal-desc Search for educators seeking various educational opportunities for their students; whether it be a request for a classroom visit, a future field trip, or even an internship offering!
        br
        br
        router-link#search-btn.educ_btns.button(to="/educator/industries") SEARCH
      #right-col.col.s11.offset-s1.m11.offset-m1.l5.offset-l1
        img.img_educ(src='@/assets/svg/Asset5.svg')
        h5 EDIT YOUR PROFILE
        p.portal-desc Set up a profile and let educators find you! Your profile allows you to communicate with local educators what oportunities you can offer them and their students.
        br
        br
        router-link#edit-btn.educ_btns.button(to="/educator/profile") EDIT
       
          

</template>

<style lang="sass" scoped>
@import '$vars'




/*****************************************/
//introduction css
/*****************************************/
#info, #opps 
  padding: .5em;


#info h6, #opps h6 
  //margin-top: -10px;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: normal;



#no-info span, #no-opps span 
  font-size: 12px;
  color: #bbbbbb;


#no-info img 
  margin: 0;



/*****************************************/

.modal-footer 
  text-align: left !important;



.banner 
  background-position: 0 30%;
  background-image: url("~@/assets/2_industryportal.jpg");
  //background-image: url("../img/2_industryportal.jpg");


.banner h4 
  padding-top: 18vh;
  font-weight: thick;
  color: #fff;


.img_educ 
  padding-top: 5em;
  max-width: 500px;


#left-col, #right-col
  padding-bottom: 15px

@media screen and (min-width: 1500px)
  #left-col 
    // padding-left: 10em
    padding-right: 10em
  #right-col 
    // padding-left: 10em
    padding-right: 10em

@media screen and (min-width: 1000px)
  #left-col 
    // padding-left: 6em
    padding-right: 6em
  #right-col 
    // padding-left: 6em
    padding-right: 6em    


#list 
  padding-left: 2em;


h5 
  color: #33404f;


p 
  font-size: 14px;


.educ_btns 
  margin-top: 4em;
  color: $chamber-orange;
  border: 2px solid $chamber-orange;
  padding: 1em 4em 1em 4em;
  font-size: 18px;
  transition: .5s;


.educ_btns:hover 
  background-color: $chamber-orange;
  color: #fff;
  transition: .5s;



#search-div 
  //padding: 4em 0 0 0 ;
  padding: 0 .75rem 0 .75rem;
  height: 50vh;


#search-tbl 
  margin-top: 7px;


.form_btns 
  margin: 0 -3px 100px -3px  !important;
  color: #ffa500;
  border: 2px solid #ffa500;
  padding: .5em 2em .5em 2em;
  font-size: 16px;



#center-btn 
  border-left: none;
  border-right: none;


.form_btns:hover 
  background-color: #ffa500;
  color: #fff;



body 
  margin-bottom: 2em;

#left-btn 
  margin-left: 0 !important;


#tbl-hdr
  background-color: #e5e5e5;
  border: 1px solid black;



</style>